export interface AppConfig {
  readonly apiBaseUrl: string;
  readonly vueSentryDsn: string;
  readonly vueSentryEnvironment: string;
  readonly vueSentryRelease: string;
  readonly vueIdpProfileSettingsUrl: string;
  readonly vueBuildVersion: string;
  readonly jupyterliteUrl?: string;
}

export type RuntimeAppConfig = Partial<AppConfig>;

const baked: AppConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  vueSentryDsn: import.meta.env.VITE_VUE_SENTRY_DSN,
  vueSentryEnvironment: import.meta.env.VITE_VUE_SENTRY_ENVIRONMENT,
  vueSentryRelease: import.meta.env.VITE_VUE_SENTRY_RELEASE,
  vueIdpProfileSettingsUrl: import.meta.env.VITE_VUE_IDP_PROFILE_SETTINGS_URL,
  vueBuildVersion: import.meta.env.VITE_VUE_BUILD_VERSION,
  jupyterliteUrl: import.meta.env.VITE_JUPYTERLITE_URL,
};

const runtime: RuntimeAppConfig = window.__APP_CONFIG__ ?? {};

export const config: AppConfig = { ...baked, ...runtime };
